<template>
    <div v-if="space.id && !list.loading" class="side-menu">
        <b class="heading">
            Topics
            <i v-if="space_permission('TOPIC_CREATE')" @click.stop="show_create = true"
               class="add-topic icon fas fa-plus-square is-pulled-right"></i>
            <span v-if="topics_loading" class="is-pulled-right loader"></span>
        </b>


        <topics-item
            v-for="topic in topics"
            @select="select_topic"
            @edit="edit_topic = topic"
            :space="space"
            :topic="topic"
            :key="topic.id"/>

        <a v-if="list.data && list.data.length > 5" @click="expand = !expand" class="menu-item">
            <span v-if="!expand">All Topics...</span>
            <span v-else>Show less...</span>
        </a>

        <div v-if="!list.data.length && !show_create" class="hint">
            There are not any topics yet.

            <span v-if="space_permission('TOPIC_CREATE')">
                Lets <u class="pointer" @click="show_create = true">create one</u>
            </span>
        </div>

        <topics-create-modal
            v-if="show_create"
            @created="edit_topic = arguments[0]"
            @close="show_create = false"
            :space="space"/>

        <!-- Edit form -->
        <topics-update-modal
            v-if="edit_topic"
            :space="space"
            :topic="edit_topic"
            @close="edit_topic = null"/>
    </div>

    <sidebar-skeleton v-else :items="5"/>
</template>

<script>
import { mapState } from 'vuex';
import SidebarSkeleton from '../skeletons/SidebarSkeleton.vue';
import TopicsCreateModal from './TopicsCreateModal.vue';
import TopicsUpdateModal from './TopicsUpdateModal.vue';
import TopicsItem from './TopicsItem.vue';

export default {
    name: 'Topics',
    props: ['space'],
    components: {
        TopicsUpdateModal, TopicsItem, TopicsCreateModal, SidebarSkeleton,
    },
    data() {
        return { show_create: false, edit_topic: null, expand: false };
    },
    computed: {
        ...mapState('topics', ['list', 'create', 'update', 'remove', 'detail']),
        topics_loading() {
            return this.update.loading
                || this.remove.loading
                || this.create.loading
                || this.detail.loading;
        },
        topics() {
            if (!this.expand) {
                return this.list.data.slice(0, 5);
            }
            return this.list.data;
        },
    },
    watch: {
        space: {
            immediate: true,
            handler(space) {
                if (!space.id) return;
                this.$store.dispatch('topics/list', { space_id: space.id });
            },
        },
    },
    methods: {
        select_topic(topic_id = null) {
            if (parseInt(this.$route.query.topic, 10) !== topic_id) {
                this.$router.replace({
                    name: 'content',
                    params: this.$route.params,
                    query: { topic: topic_id },
                });
            }
        },
    },
};
</script>

<style scoped>
    .add-topic {font-size: 0.9rem; cursor: pointer;}
    .add-topic:hover {opacity: .8}
</style>
